export default "__VITE_ASSET__Dtmezco2__"